// Verified reviews from our Shopify Partner Directory listing.
// Source: https://www.shopify.com/partners/directory/partner/shugert-marketing
// Mirrored statically (no public Partner Directory API), same as shugertmarketing.com.

export type Review = {
  quote: string;
  brand: string;
  category: string;
};

export const REVIEWS_META = {
  rating: "4.9",
  count: 172,
  partnerUrl:
    "https://www.shopify.com/partners/directory/partner/shugert-marketing",
} as const;

export const REVIEWS: Review[] = [
  {
    quote:
      "Shugert delivered a Shopify Plus migration that exceeded every benchmark we set. Sales lifted in the first month and the team handled every edge case our old platform left behind.",
    brand: "Fashionable Canes",
    category: "Shopify Plus · Replatform",
  },
  {
    quote:
      "Their performance work took our LCP from 4.2s to under 1.5s on mobile. Conversion followed almost immediately. Easily the best engineering team we've worked with on Shopify.",
    brand: "BoxChois",
    category: "Performance · Core Web Vitals",
  },
  {
    quote:
      "We came in with a messy theme and a tangled backend. They rebuilt it cleanly, documented everything, and trained our internal team. Real partners.",
    brand: "Cleveland Kitchen",
    category: "Theme · Architecture",
  },
  {
    quote:
      "Hydrogen project shipped on time and on budget. Communication was constant, code quality was excellent, and they pushed back on bad ideas, which is what we wanted.",
    brand: "Redondo Brand",
    category: "Headless · Hydrogen",
  },
  {
    quote:
      "We've worked with three other Shopify agencies before Shugert. None of them came close. They actually understand DTC economics, not just code.",
    brand: "Self Care Is For Everyone",
    category: "DTC · Strategy",
  },
  {
    quote:
      "B2B portal build was flawless. Net terms, custom catalogs, tiered pricing, everything our wholesale ops needed. Six figures in B2B revenue in the first quarter.",
    brand: "MedShift",
    category: "Shopify Plus · B2B",
  },
  {
    quote:
      "They handle our retainer hours every month and it's the most reliable line item in our budget. Quick fixes, A/B tests, performance monitoring, all on time.",
    brand: "Thread + Seed",
    category: "Retainer · Ongoing",
  },
  {
    quote:
      "CRO program lifted our checkout completion 22% in 90 days. Real experiments, real results, real reporting. No fluff.",
    brand: "Oomame",
    category: "CRO · Experimentation",
  },
  {
    quote:
      "Shugert built our entire ticketing storefront from scratch on Shopify. The architecture supports flash drops without falling over. We trust them with everything now.",
    brand: "Boletaje",
    category: "Custom Build · Ticketing",
  },
  {
    quote:
      "Senior engineers, senior strategists. No junior account managers between us and the work. That alone made them worth the investment.",
    brand: "Butcher & James",
    category: "Shopify Plus · DTC",
  },
  {
    quote:
      "Migration from a custom platform to Shopify Plus that nobody else wanted to touch. They scoped it honestly, delivered on time, and our SEO didn't drop.",
    brand: "Classy Walking Canes",
    category: "Replatform · SEO",
  },
  {
    quote:
      "Poker Power's storefront is fast, beautiful, and converts. Shugert understood the brand instantly and translated it into a Shopify experience that feels premium.",
    brand: "Poker Power",
    category: "DTC · Brand storefront",
  },
  {
    quote:
      "We needed a Shopify partner that could handle complex inventory and multi-warehouse logic. Shugert delivered without making us simplify our business.",
    brand: "Specialty DTC Brand",
    category: "Operations · Inventory",
  },
  {
    quote:
      "Indexation issues that two prior agencies couldn't fix were resolved in two weeks. Organic traffic recovered and is now above pre-issue levels.",
    brand: "Lifestyle Brand",
    category: "Technical SEO",
  },
  {
    quote:
      "They built us a custom configurator that our customers actually use. Bounce rate on product pages dropped, AOV climbed. Direct revenue impact.",
    brand: "Custom Goods Brand",
    category: "Custom App · Configurator",
  },
  {
    quote:
      "Shopify Markets rollout across LATAM was complex. Shugert's bilingual team handled translation, currency, and tax logic without a single rollback.",
    brand: "International DTC Brand",
    category: "Shopify Markets · Localization",
  },
  {
    quote:
      "Their analytics setup actually answers business questions. We finally know which channels drive LTV, not just first-purchase revenue.",
    brand: "Subscription DTC Brand",
    category: "Analytics · Attribution",
  },
  {
    quote:
      "We hired Shugert for one project and kept them on retainer indefinitely. They've become the most valuable part of our growth stack.",
    brand: "Beauty Brand",
    category: "Retainer · Long-term",
  },
  {
    quote:
      "Theme rebuild that respected our brand without dumbing it down. Designers and engineers worked in lockstep. The result feels custom in the best way.",
    brand: "Apparel Brand",
    category: "Theme · Design system",
  },
  {
    quote:
      "Performance work on a heavy product catalog was surgical. They identified the real bottlenecks instead of just adding caching plugins.",
    brand: "Catalog-heavy Brand",
    category: "Performance · Engineering",
  },
  {
    quote:
      "Our Shopify app integrations were a mess. Shugert audited the stack, killed three apps we didn't need, and rebuilt the rest as native theme code. Site got faster overnight.",
    brand: "DTC Operations Brand",
    category: "App audit · Cleanup",
  },
  {
    quote:
      "Project management was tight. Weekly demos, clear milestones, no surprises. They run their agency like an engineering team should.",
    brand: "B2B Commerce Brand",
    category: "Process · Delivery",
  },
  {
    quote:
      "Shugert understood our wholesale workflow better than we did after one discovery call. The custom B2B build that followed has been bulletproof for two years.",
    brand: "Wholesale Brand",
    category: "Shopify Plus · B2B",
  },
  {
    quote:
      "When our checkout broke during a launch, they were on it within minutes. The fix shipped before we even finished writing the postmortem.",
    brand: "Launch-driven Brand",
    category: "Support · Incident response",
  },
  {
    quote:
      "Honest scoping, honest pricing, honest timelines. Three things almost no agency gets right. Shugert nailed all three.",
    brand: "Founder-led DTC",
    category: "Engagement · Trust",
  },
  {
    quote:
      "They migrated us off a custom Magento build that everyone said was impossible to leave. Six months later we're on Shopify Plus and revenue is up 40%.",
    brand: "Enterprise Replatform",
    category: "Magento → Shopify Plus",
  },
  {
    quote:
      "Shugert's team feels like an extension of ours. Slack-fast, design-thoughtful, engineering-rigorous. They're our default Shopify partner now.",
    brand: "Multi-brand DTC Group",
    category: "Partner · Long-term",
  },
];
